import React from 'react'
import PageTitle from './PageTitle'

const Page = (props) => {
    return (
        <React.Fragment>
            <PageTitle title={props.title} />
            {props.children}
        </React.Fragment>
    )
}

export default Page;


// WEBPACK FOOTER //
// ./src/components/Page.js